var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network-vlt",class:(_vm.isOnline) ? 'online-div':'offline-div'},[_c('img',{staticClass:"image",class:!_vm.isOnline?'offline-image':'',attrs:{"src":_vm.imagesrc,"alt":"image","loading":"lazy"}}),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }